import {combineReducers} from 'redux';
import genericReducer from 'common/reducers/generic-reducer';
import reportPreviewReducer from 'common/reducers/report-preview-reducer';

export default combineReducers({
  enums: genericReducer,
  report: reportPreviewReducer,
  settings: genericReducer,
});
